// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"187":"2b95303c","252":"5f78f310","964":"2e8622d0"}[chunkId] + ".js";
};